webpackJsonp([295],{

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreCollectionTable_vue__ = __webpack_require__(2992);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c425c884_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreCollectionTable_vue__ = __webpack_require__(5455);
function injectStyle (ssrContext) {
  __webpack_require__(5453)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c425c884"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreCollectionTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c425c884_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreCollectionTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 2992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table__ = __webpack_require__(1346);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table__["b" /* default */]],
  data: function data() {
    return {
      search: {
        market_id: '',
        gatherinfo_status: '',
        gatherinfo_need_export: null,
        gatherinfo_times: '',
        update_start: [],
        update_end: [],
        province_id: '',
        city_id: '',
        area_id: ''
      },
      searchRules: {
        market_id: [{ validator: this.positiveIntegerValidator, trigger: 'blur' }],
        update_end: [{ validator: this.updateEndValidator, trigger: 'blur' }]
      },
      searchFieldType: {
        market_id: Number,
        gatherinfo_status: Number,
        gatherinfo_need_export: Number
      },
      inLoading: {
        province: false,
        city: false,
        area: false
      },

      options: {
        status: [{ label: '全部', value: '' }, { label: '不收集', value: 1 }, { label: '待收集', value: 2 }, { label: '收集中', value: 3 }, { label: '收集完成', value: 4 }, { label: '信息确认', value: 5 }],
        province: [],
        city: [],
        area: [],
        result: [{ label: '正常', value: 0 }, { label: '不一致', value: 1 }]
      },
      maps: {
        status: {
          '1': '不收集',
          '2': '待收集',
          '3': '收集中',
          '4': '收集完成',
          '5': '信息确认'
        },
        result: {
          '0': '正常',
          '1': '不一致'
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    this.inLoading.province = true;

    request.page('getProvinceList').then(function (_ref) {
      var data = _ref.data;

      _this.options.province = data;
      _this.inLoading.province = false;
    }).catch(function () {
      _this.inLoading.province = false;
    });

    if (this.$route.query.province_id) {
      this.inLoading.city = true;

      request.page('getCityList', this.$route.query.province_id).then(function (_ref2) {
        var data = _ref2.data;

        _this.options.city = data;
        _this.inLoading.city = false;
      }).catch(function () {
        _this.options.city = [];
        _this.inLoading.city = false;
      });
    }

    if (this.$route.query.city_id) {
      this.inLoading.area = true;

      request.page('getAreaList', this.$route.query.city_id).then(function (_ref3) {
        var data = _ref3.data;

        _this.options.area = data;
        _this.inLoading.area = false;
      }).catch(function () {
        _this.options.area = [];
        _this.inLoading.area = false;
      });
    }
  },


  methods: {
    getTableData: function getTableData(params) {
      return request.page('getStoreCollectionTable', params);
    },
    updateEndValidator: function updateEndValidator(rule, value, callback) {
      if (Date.parse(this.search.update_end) <= Date.parse(this.search.update_start)) {
        callback(new Error('更新结束时间必须晚于更新开始时间'));
      } else {
        callback();
      }
    },
    onChangeProvince: function onChangeProvince(val) {
      var _this2 = this;

      this.search.city_id = '';
      this.search.area_id = '';

      if (val) {
        this.inLoading.city = true;

        request.alert('getCityList', val).then(function (_ref4) {
          var data = _ref4.data;

          _this2.options.city = data;
          _this2.inLoading.city = false;
        }).catch(function () {
          _this2.options.city = [];
          _this2.inLoading.city = false;
        });
      } else {
        this.options.city = [];
      }
    },
    onChangeCity: function onChangeCity(val) {
      var _this3 = this;

      this.search.area_id = '';

      if (val) {
        this.inLoading.area = true;

        request.alert('getAreaList', val).then(function (_ref5) {
          var data = _ref5.data;

          _this3.options.area = data;
          _this3.inLoading.area = false;
        }).catch(function () {
          _this3.options.area = [];
          _this3.inLoading.area = false;
        });
      } else {
        this.options.area = [];
      }
    },


    // 验证正整数输入
    positiveIntegerValidator: function positiveIntegerValidator(rule, value, callback) {
      if (value && !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    },
    onExportSearch: function onExportSearch() {
      var _this4 = this;

      this.$export(this.$route.meta.title, {
        type: 'array',
        request: function (_request) {
          function request(_x) {
            return _request.apply(this, arguments);
          }

          request.toString = function () {
            return _request.toString();
          };

          return request;
        }(function (params) {
          return request('exportStoreCollectionTable', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this4.search, params));
        }),
        getResponseData: function getResponseData(data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1);
          return data;
        }
      });
    }
  }
});

/***/ }),

/***/ 5453:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5454);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("57f6f8a8", content, true, {});

/***/ }),

/***/ 5454:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".custom-form .re-el-form__flex[data-v-c425c884]{margin:0}.custom-form .el-select[data-v-c425c884]{width:100%}.custom-form .form-panel[data-v-c425c884]{width:100%;margin:15px 0 0}.custom-form .form-slider[data-v-c425c884]{padding:0 0 0 10px}.popover-table[data-v-c425c884]{position:fixed;top:0;bottom:0;left:0;right:0;margin:0;background-color:rgba(0,0,0,.5);z-index:999}.popover-table .popover-table-body[data-v-c425c884]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;max-height:80%;min-height:200px;max-width:80%;margin:auto;background-color:#fff;border-radius:5px;overflow:hidden}.popover-table .popover-table-body>div[data-v-c425c884]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:15px}.popover-table .popover-table-body .popover-table-header[data-v-c425c884]{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:900;color:#666;border-bottom:1px dashed #aaa}.popover-table .popover-table-body .popover-table-content[data-v-c425c884]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto}", "", {"version":3,"sources":["/workspace/src/views/platform-user/style/PlatformUser.scss"],"names":[],"mappings":"AACA,gDAAgD,QAAQ,CACvD,AACD,yCAAyC,UAAU,CAClD,AACD,0CAA0C,WAAW,eAAe,CACnE,AACD,2CAA2C,kBAAkB,CAC5D,AACD,gCAAgC,eAAe,MAAM,SAAS,OAAO,QAAQ,SAAS,gCAAiC,WAAW,CACjI,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,4BAA4B,wBAAwB,uBAAuB,oBAAoB,2BAA2B,eAAe,iBAAiB,cAAc,YAAY,sBAAsB,kBAAkB,eAAe,CAC5Y,AACD,wDAAwD,WAAW,8BAA8B,sBAAsB,YAAY,CAClI,AACD,0EAA0E,mBAAmB,oBAAoB,YAAY,oBAAoB,cAAc,eAAe,gBAAgB,WAAW,6BAA6B,CACrO,AACD,2EAA2E,mBAAmB,oBAAoB,YAAY,oBAAoB,cAAc,aAAa,CAC5K","file":"PlatformUser.scss","sourcesContent":["\n.custom-form .re-el-form__flex[data-v-c425c884]{margin:0\n}\n.custom-form .el-select[data-v-c425c884]{width:100%\n}\n.custom-form .form-panel[data-v-c425c884]{width:100%;margin:15px 0 0\n}\n.custom-form .form-slider[data-v-c425c884]{padding:0 0 0 10px\n}\n.popover-table[data-v-c425c884]{position:fixed;top:0;bottom:0;left:0;right:0;margin:0;background-color:rgba(0,0,0,0.5);z-index:999\n}\n.popover-table .popover-table-body[data-v-c425c884]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;max-height:80%;min-height:200px;max-width:80%;margin:auto;background-color:#FFF;border-radius:5px;overflow:hidden\n}\n.popover-table .popover-table-body>div[data-v-c425c884]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:15px\n}\n.popover-table .popover-table-body .popover-table-header[data-v-c425c884]{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:900;color:#666;border-bottom:1px dashed #AAA\n}\n.popover-table .popover-table-body .popover-table-content[data-v-c425c884]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":true}},[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",staticClass:"layout-search-form medium",attrs:{"model":_vm.search,"rules":_vm.searchRules,"label-width":"110px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',[_c('el-form-item',{attrs:{"label":"门店ID：","prop":"market_id"}},[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.search.market_id),callback:function ($$v) {_vm.$set(_vm.search, "market_id", _vm._n($$v))},expression:"search.market_id"}})],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"label":"信息收集状态：","prop":"gatherinfo_status"}},[_c('el-select',{model:{value:(_vm.search.gatherinfo_status),callback:function ($$v) {_vm.$set(_vm.search, "gatherinfo_status", $$v)},expression:"search.gatherinfo_status"}},_vm._l((_vm.options.status),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"label":"省份：","prop":"province_id"}},[_c('el-select',{attrs:{"loading":_vm.inLoading.province,"clearable":""},on:{"change":_vm.onChangeProvince},model:{value:(_vm.search.province_id),callback:function ($$v) {_vm.$set(_vm.search, "province_id", $$v)},expression:"search.province_id"}},_vm._l((_vm.options.province),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"label":"城市：","prop":"city_id"}},[_c('el-select',{attrs:{"loading":_vm.inLoading.city,"disabled":!_vm.search.province_id,"clearable":""},on:{"change":_vm.onChangeCity},model:{value:(_vm.search.city_id),callback:function ($$v) {_vm.$set(_vm.search, "city_id", $$v)},expression:"search.city_id"}},_vm._l((_vm.options.city),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"label":"地区：","prop":"area_id"}},[_c('el-select',{attrs:{"loading":_vm.inLoading.area,"disabled":!_vm.search.province_id || !_vm.search.city_id,"clearable":""},model:{value:(_vm.search.area_id),callback:function ($$v) {_vm.$set(_vm.search, "area_id", $$v)},expression:"search.area_id"}},_vm._l((_vm.options.area),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"label":"收集结果","prop":"gatherinfo_need_export"}},[_c('el-select',{attrs:{"clearable":""},model:{value:(_vm.search.gatherinfo_need_export),callback:function ($$v) {_vm.$set(_vm.search, "gatherinfo_need_export", $$v)},expression:"search.gatherinfo_need_export"}},_vm._l((_vm.options.result),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"prop":"update_start","label":"开启收集时间:"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center"},model:{value:(_vm.search.update_start),callback:function ($$v) {_vm.$set(_vm.search, "update_start", $$v)},expression:"search.update_start"}})],1)],1),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"prop":"update_end","label":"完成收集时间:"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center"},model:{value:(_vm.search.update_end),callback:function ($$v) {_vm.$set(_vm.search, "update_end", $$v)},expression:"search.update_end"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.search.gatherinfo_need_export === 0},on:{"click":function($event){return _vm.onExportSearch()}}},[_vm._v("导出\n        ")])],1)],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-table',{ref:"multipleTable",attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{attrs:{"prop":"market_id","label":"门店ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marketname","label":"卖场名称"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"province_name","label":"省市区"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.province_name)+"-"+_vm._s(scope.row.city_name)+"-"+_vm._s(scope.row.area_name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"gatherinfo_times","label":"收集次数"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"gatherinfo_status","label":"信息收集状态"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.maps.status[scope.row.gatherinfo_status] || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"gatherinfo_count","label":"收集工单数"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"last_gatherinfo_start","label":"开始收集时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"last_gatherinfo_at","label":"完成收集时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"gatherinfo_need_export","label":"收集结果"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.gatherinfo_status * 1 === 4 ? _vm.maps.result[scope.row.gatherinfo_need_export] : '-'))])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/StoreCollectionTable.f0a0aae6e821e2e1382e.js